const trackEvents = {
    init() {
    this.trackSearchPerformed();
    this.trackSearchClick();
    this.trackSortApplied();
    },
    trackSearchPerformed() {
        if (window.location.pathname.includes('/search')) {
            const urlParams = new URLSearchParams(window.location.search);
            const searchTerm = urlParams.get('q') || '';
            let resultCount = 0;
            const resultElement = document.querySelector('#ProductCountDesktop');
            if (resultElement) {
                const match = resultElement.textContent.match(/\d+/);
                if (match) {
                    resultCount = parseInt(match[0], 10);
                }
            }
            const success = resultCount > 0 ? 1 : 0;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'search',
                content_type: 'search results',
                search_term: searchTerm,
                search_results: resultCount,
                success: success
            });
        }
    },

   trackSearchClick() {
    if (window.location.pathname.includes('/search')) {
    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q') || '';
    document.addEventListener('click', function (e) {
      const link = e.target.closest('a');
      // Remove or adjust this condition based on actual DOM
      if (link && link.href.includes('/products/')) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'search_result_click',
          content_type: 'search result item',
          search_term: searchTerm,
          clicked_url: link.href
        });
      }
    });
  }
},


// ... (searchPerformed & searchClick from earlier)
trackSortApplied() {
  if (window.location.pathname.includes('/search')) {
    const sortSelect = document.querySelector('select[name="sort_by"], select#SortBy');    
    if (!sortSelect) {
      return;
    }
    sortSelect.addEventListener('change', function () {
      const selectedValue = sortSelect.value;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'sort',
        content_type: 'products',
        filter_term: selectedValue,
        filter_path: selectedValue
      });
    });
  }
}

};
document.addEventListener('DOMContentLoaded', () => {
    trackEvents.init();
});